import {
    cilAirplaneMode,
    cilArrowRight,
    cilBan,
    cilBarChart,
    cilBell,
    cilBriefcase,
    cilCalendar,
    cilCaretBottom,
    cilCaretTop,
    cilChartLine,
    cilCheck,
    cilCheckAlt,
    cilCheckCircle,
    cilChevronBottom,
    cilChevronTop,
    cilClipboard,
    cilClock,
    cilCloudDownload,
    cilCloudUpload,
    cilCog,
    cilDataTransferDown,
    cilDescription,
    cilEnvelopeClosed,
    cilExternalLink,
    cilFile,
    cilFork,
    cilGroup,
    cilImagePlus,
    cilInfo,
    cilLanguage,
    cilLayers,
    cilList,
    cilListFilter,
    cilLockLocked,
    cilLockUnlocked,
    cilLoop,
    cilMedicalCross,
    cilMenu,
    cilMobile,
    cilNotes,
    cilPaperclip,
    cilPaperPlane,
    cilPencil,
    cilPhone,
    cilPlus,
    cilQrCode,
    cilScreenDesktop,
    cilSitemap,
    cilTag,
    cilTags,
    cilTrash,
    cilUser,
    cilViewColumn,
    cilWarning,
    cilX,
    cilXCircle,
    flagSet,
} from '@coreui/icons';

import { logoCurie, logoLarge, logoSmall } from './logo';

export const iconsSet = Object.assign(
    {},
    { logoSmall, logoLarge, logoCurie },
    flagSet,
    {
        cilAirplaneMode,
        cilArrowRight,
        cilBan,
        cilBarChart,
        cilBell,
        cilBriefcase,
        cilCalendar,
        cilCaretBottom,
        cilCaretTop,
        cilChartLine,
        cilCheck,
        cilCheckAlt,
        cilCheckCircle,
        cilChevronBottom,
        cilChevronTop,
        cilClipboard,
        cilClock,
        cilCloudDownload,
        cilCloudUpload,
        cilCog,
        cilDataTransferDown,
        cilDescription,
        cilEnvelopeClosed,
        cilExternalLink,
        cilFile,
        cilFork,
        cilGroup,
        cilImagePlus,
        cilInfo,
        cilLanguage,
        cilLayers,
        cilList,
        cilListFilter,
        cilLockLocked,
        cilLockUnlocked,
        cilLoop,
        cilMedicalCross,
        cilMenu,
        cilMobile,
        cilNotes,
        cilPaperclip,
        cilPaperPlane,
        cilPencil,
        cilPhone,
        cilPlus,
        cilQrCode,
        cilScreenDesktop,
        cilSitemap,
        cilTag,
        cilTags,
        cilTrash,
        cilUser,
        cilViewColumn,
        cilWarning,
        cilX,
        cilXCircle,
    },
);
